<template>
    <table class="table is-fullwidth is-kv">
        <tr>
            <td style="width: 250px;">Id</td>
            <td>{{ device.id }}</td>
        </tr>

        <tr>
            <td>Code</td>
            <td>{{ device.code }}</td>
        </tr>

        <tr>
            <td>Manufacturer</td>
            <td>{{ device.manufacturer }}</td>
        </tr>

        <tr>
            <td>Model</td>
            <td>{{ device.model }}</td>
        </tr>

        <tr>
            <td>Operating System</td>
            <td>
                {{ device.os }} -
                {{ device.os_version + ' : ' + device.os_version_number }}
            </td>
        </tr>

        <tr>
            <td>App Version</td>
            <td>{{ device.app_version }}</td>
        </tr>

        <tr>
            <td>Network</td>
            <td>{{ device.operator }}</td>
        </tr>

        <tr>
            <td>FCM</td>
            <td>
                <div style="word-break: break-all;">
                    {{ device.fcm }}
                </div>
            </td>
        </tr>

        <tr>
            <td>Ipv4</td>
            <td>{{ device.ipv4 }}</td>
        </tr>

        <tr>
            <td>Country</td>
            <td>{{ device.ip_based_country_code }}</td>
        </tr>

        <tr>
            <td>Locale</td>
            <td>{{ device.locale }}</td>
        </tr>

        <tr>
            <td>Created At</td>
            <td>{{ device.created_at }}</td>
        </tr>
    </table>
</template>

<script>
export default {
    props: ['device']
};
</script>

<style>
.table.is-kv tr td:first-child {
    font-weight: 500;
}
</style>
